import { IInputItems } from '@/typings';

export const tipoFaturamentoOdonto: IInputItems[] = [
  { label: 'PARCIAL', value: '1' },
  { label: 'TOTAL', value: '4' },
];
